(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["bouss-storytelling"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const init = (sec) => {
      const textEl = sec.querySelector('[data-bstory-text]');
      const scroll = sec.querySelector('.bstory__scroll');
      if (!scroll) return;
      const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      let spans = [];
      if (textEl) {
        const goldLast = parseInt(sec.dataset.goldLast || '0', 10);
        const words = textEl.textContent.trim().split(/\s+/);
        textEl.textContent = '';
        spans = words.map((w, i) => {
          const s = document.createElement('span');
          s.className = 'bstory__w' + (goldLast > 0 && i >= words.length - goldLast ? ' bstory__w--gold' : '');
          s.textContent = w;
          textEl.appendChild(s);
          if (i < words.length - 1) textEl.appendChild(document.createTextNode(' '));
          return s;
        });
      }

      const io = new IntersectionObserver((entries) => {
        entries.forEach((e) => sec.classList.toggle('is-in', e.isIntersecting));
      }, { threshold: 0.01 });
      io.observe(sec);

      if (reduce) { sec.classList.add('is-in', 'is-done'); return; }

      const dim = parseFloat(getComputedStyle(sec).getPropertyValue('--bstory-dim')) || 0.16;
      let ticking = false;
      const onScroll = () => {
        if (ticking) return;
        ticking = true;
        requestAnimationFrame(() => {
          ticking = false;
          const r = scroll.getBoundingClientRect();
          const total = r.height - window.innerHeight;
          const p = total > 0 ? Math.min(1, Math.max(0, -r.top / total)) : 0;
          const tp = Math.min(1, Math.max(0, (p - 0.12) / 0.7));
          const lit = tp * spans.length;
          for (let i = 0; i < spans.length; i++) {
            spans[i].style.opacity = Math.min(1, Math.max(dim, lit - i + dim)).toFixed(3);
          }
          sec.classList.toggle('is-done', tp > 0.92);
        });
      };
      onScroll();
      window.addEventListener('scroll', onScroll, { passive: true });
      window.addEventListener('resize', onScroll);
    };
    document.querySelectorAll('[data-bstory]').forEach(init);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-list"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const init = (sec) => {
      if (sec.dataset.lm !== 'true' || sec.dataset.layout !== 'grid') return;
      const items = Array.from(sec.querySelectorAll('.resource-list__item'));
      const wrap = sec.querySelector('[data-bouss-more]');
      const btn = sec.querySelector('[data-bouss-more-btn]');
      if (!wrap || !btn || !items.length) return;
      const step = Math.max(1, parseInt(sec.dataset.initial, 10) || 8);
      let shown = step;
      const apply = () => {
        items.forEach((it, i) => { it.hidden = i >= shown; });
        wrap.hidden = shown >= items.length;
      };
      apply();
      btn.addEventListener('click', () => { shown += step; apply(); });
    };
    document.querySelectorAll('[data-bouss-list]').forEach(init);
  })();

  } catch(e) { console.error(e); }
})();
})();
